import axios from "axios";
import { API_BASE_URL, ENDPOINTS } from "@/config/api.enpoints";

export interface ContactFormPayload {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  message: string;
}

export const sendContactForm = async (payload: FormData) => {
  const url = `${API_BASE_URL}${ENDPOINTS.CONTACT.sendMessage}`;
  try {
    const response = await axios.post(url, payload);
    return response.data;
  } catch (error: unknown) {
    console.error("Failed to send contact form:", error);

    if (axios.isAxiosError(error)) {
      // Axios error with response
      throw (
        error.response?.data || {
          message: error.message || "Something went wrong",
        }
      );
    }

    // Generic fallback error
    throw { message: "An unexpected error occurred" };
  }
};
